module.exports = __webpack_public_path__ + "img/pick4.4610fd8c.png";